import React, { useEffect, useState } from "react";
import { fetch } from "../../actions";
import { connect } from "react-redux";
import { useFetch } from "../../components/Hooks/Conexao";
import * as api from "../Balcao/api";
import TabelaPadrao from "../../components/TabelaPadrao";
import { InputPadrao, LabelPadrao, DatePickerPadrao, LoadingContainerPadrao, CheckBoxPadrao, ModalPadrao } from "../../components/Base";
import { Divider, Menu, Popover } from "antd";
import dayjs from "dayjs";
import Mensagens from "../../components/Mensagens";
import RecuperarDetalhe from "./RecuperarDetalhe";
import { useSave } from '../../components/Hooks/Conexao';
import { BtnCancelar, BtnListar, BtnPadrao, BtnSair } from "../../components/Buttons";
import SelectPesq from "../../components/Selects/SelectPesq";
import { useLocalStorage } from "../../components/Hooks/useLocalStorage";
import ImpressaoPreVenda from "../Impressao/ImpressaoPreVenda";

function Recuperar({ onOk, visible, onCancel, ...props }) {
  const [filtrosData, setFiltrosData] = useState({ dtIni: dayjs(), dtFim: dayjs(), });
  const [filtrosTipo, setFiltrosTipo, saveState, inicializado] = useLocalStorage("filtros_recuperar_prevenda", { prevenda: true, orcamento: false });
  const [marcados, setMarcados] = useState([]);
  const [dados, listar, loadingDados] = useFetch(() => api.get(props.fetch, filtros));
  const [recuperar, recuperando] = useSave();
  const [cancelar, loadingCan] = useSave(() => api.Delete(props.fetch, marcados[0], ""), () => { Mensagens.showSucesso("Pré-venda cancelada com sucesso!"); listar(); });
  const [id, setId] = useState(null);
  const [idImpressao, setIdImpressao] = useState(null);

  const filtros = { ...filtrosData, ...filtrosTipo };

  useEffect(() => {
    if (!!visible)
      listar(() => api.get(props.fetch, filtros));

    setMarcados([]);
  }, [visible]);

  useEffect(() => setMarcados([]), [loadingDados]);

  useEffect(() => {
    if (inicializado)
      saveState(filtrosTipo);
  }, [filtrosTipo]);

  const menu = <Menu>
    <Menu.Item>
      <CheckBoxPadrao checked={filtrosTipo.prevenda} onChange={() => setFiltrosTipo({ ...filtrosTipo, prevenda: !filtrosTipo.prevenda })}>Pré-Vendas</CheckBoxPadrao>
    </Menu.Item>
    <Menu.Item>
      <CheckBoxPadrao checked={filtrosTipo.orcamento} onChange={() => setFiltrosTipo({ ...filtrosTipo, orcamento: !filtrosTipo.orcamento })}>Orçamentos</CheckBoxPadrao>
    </Menu.Item>
  </Menu>;

  const recuperarHandler = cb => recuperar(() => api.recuperar(props.fetch, marcados[0]), cb);

  return <ModalPadrao width={window.innerWidth < 1200 ? window.innerWidth : 1200} title="Recuperar" footer={null} visible={visible} onCancel={onCancel}>
    <LoadingContainerPadrao loading={loadingDados || loadingCan}>
      <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div style={{ width: "30%" }}>
          <LabelPadrao noMargin>Vendedor</LabelPadrao>
          <SelectPesq style={{ width: "100%" }} placeholder="Pesquisar o vendedor" modelo="vendedor" value={filtrosData.vendedor} onChange={id => setFiltrosData({ ...filtrosData, vendedor: id })} />
        </div>
        <div style={{ width: "30%", margin: "0 10px" }}>
          <LabelPadrao noMargin>Número</LabelPadrao>
          <InputPadrao onPressEnter={listar} style={{ width: "100%" }} placeholder="Pesquisar" value={filtrosData.numero} onChange={e => setFiltrosData({ ...filtrosData, numero: e.target.value })} />
        </div>
        <div style={{ width: "30%" }}>
          <LabelPadrao noMargin>Período</LabelPadrao>
          <div style={{ display: "flex", width: "100%" }}>
            <DatePickerPadrao value={filtrosData.dtIni} onChange={v => setFiltrosData({ ...filtrosData, dtIni: v })} style={{ marginRight: 10, width: "50%" }} />
            <DatePickerPadrao value={filtrosData.dtFim} onChange={v => setFiltrosData({ ...filtrosData, dtFim: v })} style={{ width: "50%" }} />
          </div>
        </div>
        <div style={{ margin: "0 10px" }}>
          <Popover content={menu} placement="bottom" >
            <BtnPadrao style={{ width: 120 }}>Tipo</BtnPadrao>
          </Popover>
        </div>
        <BtnListar onClick={listar} />
      </div>
      <div style={{ minHeight: "50vh" }}>
        <TabelaPadrao columns={columns} data={dados} style={{ marginTop: 25 }} marcados={marcados} setMarcados={setMarcados} checkOnlyOne setDetalhe={v => setId(v.id)} />
      </div>
      <Divider />
      <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
        <div style={{ display: "flex" }}>
          <BtnCancelar onClick={cancelar} disabled={!marcados.length || recuperando} showConfirm />
          <BtnPadrao style={{ marginLeft: 10 }} onClick={() => setIdImpressao(marcados[0])} disabled={!marcados.length || recuperando}>Imprimir</BtnPadrao>
        </div>
        <div>
          <BtnPadrao style={{ margin: "0 10px" }} loading={recuperando} onClick={() => recuperarHandler(onOk)} disabled={!marcados.length}>Recuperar</BtnPadrao>
          <BtnSair onClick={onCancel} />
        </div>
      </div>
    </LoadingContainerPadrao>

    <RecuperarDetalhe onCancel={() => setId(null)} id={id} />

    <ImpressaoPreVenda id={idImpressao} onCancel={() => setIdImpressao(null)} style={{ marginLeft: 10 }} />

  </ModalPadrao>;
}
export default connect(null, { fetch })(Recuperar);

const columns = [
  {
    Header: "Data",
    accessor: "data",
    tipo: "dthr"
  },
  {
    Header: "Vendedor",
    accessor: "vendedor",
  },
  {
    Header: "Número",
    accessor: "numero",
  },
  {
    Header: "Tipo",
    accessor: "tipo"
  },
  {
    Header: "Cliente",
    accessor: "cliente",
  },
  {
    Header: "Valor Bruto",
    accessor: "valorProdutos",
    tipo: "rs",
  },
  {
    Header: "Valor Líquido",
    accessor: "valorTotal",
    tipo: "rs",
  },
];
